/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { colors } from '@farmlands/mui-theme';
import { Box } from '@mui/material';
import Typography from './Typography';
import { styled } from '@mui/system';

export interface BannerProps {
  symbol: string | React.ReactNode;
  title: string | React.ReactNode;
  body: string | React.ReactNode;
  color?: keyof typeof colors;
  testId?: string;
  sx?: React.CSSProperties;
}

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  padding: 0.5rem 1rem;
  gap: 1rem;
`;

const Icon = styled('span')<{ color: keyof typeof colors }>`
  color: ${({ color }) => colors[color]};
`;
export const Banner: React.FC<BannerProps> = ({ body, title, symbol, testId, sx, color }) => {
  return (
    <Container sx={sx} bgcolor={color ? colors[color] : colors.primary100} data-testid={testId}>
      <Box display='flex' alignItems='center' justifyContent={'center'}>
        {typeof symbol === 'string' ? (
          <Icon className='material-symbols-outlined' color={color ?? 'primary500'}>
            {symbol}
          </Icon>
        ) : (
          symbol
        )}
      </Box>

      <Box>
        {typeof title === 'object' && title}
        {typeof title === 'string' && (
          <Typography variant='body2' fontWeight={700} color={'primary700'}>
            {title}
          </Typography>
        )}
        {typeof body === 'object' && body}
        {typeof body === 'string' && (
          <Typography variant='body2' color={'primary500'}>
            {body}
          </Typography>
        )}
      </Box>
    </Container>
  );
};
